import { Drawer } from "antd";
import { useState } from "react";
import close from "./../../../assets/images/close.svg";
import QualificationList from "./QualificationList";
import SearchBar from "./SearchBySpeciality";

const QualificationSheet = ({
    show,
    closePopup,
    qualifications,
    handleQualification,
    selectedQualifications,
    removeQualificationByCode,
    toggleAllQualifications
}: any) => {
    const [searchTerm, setSearchTerm] = useState("");
    const filteredQualifications = searchTerm
        ? qualifications?.filter((s: any) =>
            s?.code?.toLowerCase().includes(searchTerm?.toLowerCase())
        )
        : qualifications;
    const finalQualifications = selectedQualifications?.length > 0
        ? [
            ...selectedQualifications,
            ...filteredQualifications.filter((v: any) => !selectedQualifications.some((q: any) => q.id === v.id))
        ]
        : filteredQualifications;

    return (
        <Drawer
            placement="bottom"
            onClose={() => {
                setSearchTerm("");
                closePopup();
            }}
            closeIcon={false}
            open={show}
            height="90vh"
            className="rounded-t-2xl overflow-hidden max-h-[90vh]"
            style={{ maxWidth: "1280px", margin: "auto" }}
        >
            <div className="flex flex-col">
                <div className="flex justify-between items-center">
                    <div className="font-semibold text-lg">Select Qualification{selectedQualifications?.length > 1 ? <>({selectedQualifications?.length})</> : <></>}</div>
                    <img src={close} alt="close" onClick={closePopup} />
                </div>
            </div>
            <section className="flex flex-col text-base bg-white rounded-3xl w-full">
                <SearchBar value={searchTerm} onChange={setSearchTerm} label={'Search by qualification'} />
                <QualificationList
                    onQualificationSelect={(value) => {
                        setSearchTerm("");
                        handleQualification(value);
                    }}
                    qualifications={finalQualifications}
                    selectedQualifications={selectedQualifications}
                    removeQualification={removeQualificationByCode}
                    onToggleSelectAll={(selectAll: boolean) =>
                        toggleAllQualifications?.(finalQualifications, selectAll)
                    }
                />
            </section>
        </Drawer>
    );
};

export default QualificationSheet;
